import React from 'react'
import Style from '../../details.module.css'
import ConnectorIcon from '../../../../SharedComponents/ConnectorIcon/ConnectorIcon'

/** Rough icon match on the entity name, with a neutral fallback. */
const iconFor = (entityName) => {
    const name = (entityName || '').toLowerCase()
    if (name.indexOf('customer') !== -1) return 'uil-user'
    if (name.indexOf('product') !== -1) return 'uil-box'
    if (name.indexOf('order') !== -1) return 'uil-receipt'
    if (name.indexOf('invoice') !== -1) return 'uil-file-alt'
    if (name.indexOf('ship') !== -1) return 'uil-truck'
    if (name.indexOf('categor') !== -1) return 'uil-apps'
    if (name.indexOf('inventor') !== -1 || name.indexOf('stock') !== -1) return 'uil-cube'
    return 'uil-database'
}

const EntityCard = ({ entityName, sourceCount, targetCount, sourceShortName, targetShortName }) => {
    const outbound = sourceCount || 0
    const inbound = targetCount || 0
    const erpLabel = sourceShortName || 'ERP'
    const ecommerceLabel = targetShortName || 'EC'

    return (
        <div className="col-lg-6">
            <article className={Style.entityCard}>
                <header className={Style.entityHeader}>
                    <span className={Style.entityIcon}>
                        <i className={iconFor(entityName)} aria-hidden="true" />
                    </span>
                    <h5 className={Style.entityName} title={entityName}>{entityName}</h5>
                    <span className={Style.entityTotal}>{outbound + inbound}</span>
                </header>

                <div className={Style.syncRow}>
                    <span className={Style.endpointIcon} title={erpLabel}>
                        <ConnectorIcon shortName={erpLabel} className={Style.endpointIconImg} />
                    </span>
                    <div className={Style.flows}>
                        <div className={Style.flow} title={`${erpLabel} to ${ecommerceLabel}`}>
                            <span className={Style.flowCount}>{outbound}</span>
                        </div>
                        <div className={`${Style.flow} ${Style.flowReverse}`} title={`${ecommerceLabel} to ${erpLabel}`}>
                            <span className={Style.flowCount}>{inbound}</span>
                        </div>
                    </div>
                    <span className={Style.endpointIcon} title={ecommerceLabel}>
                        <ConnectorIcon shortName={ecommerceLabel} className={Style.endpointIconImg} />
                    </span>
                </div>
            </article>
        </div>
    )
}

export default EntityCard
